// extracted by mini-css-extract-plugin
module.exports = {"background":"Modal-module--background--2rzXz","buttons":"Modal-module--buttons--1DgyK","modal":"Modal-module--modal--2Jgwu"};